import { Link } from "react-router-dom";
import { useIntl } from "../../lib/i18n";

export default function PlatformPage() {
  const { t } = useIntl();
  const items: [string, string][] = [
    ["/admin/platform/tenants", t("platform.tenants.title")],
    ["/admin/platform/audit-log", t("platform.audit.title")],
    ["/admin/platform/observability", t("platform.observability.title")],
  ];
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("platform.title")}</h1>
      <p className="mt-2 text-slate-500">{t("platform.welcome")}</p>
      <ul className="mt-6 space-y-2">
        {items.map(([href, label]) => (
          <li key={href}>
            <Link to={href} className="text-brand-700 hover:underline">
              {label} ›
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
